import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'hu',
  Pagination: {
    items_per_page: '/ oldal',
    jump_to: 'Ugrás',
    jump_to_confirm: 'megerősít',
    page: '',
    prev_page: 'Előző oldal',
    next_page: 'Következő oldal',
    prev_5: 'Előző 5 oldal',
    next_5: 'Következő 5 oldal',
    prev_3: 'Előző 3 oldal',
    next_3: 'Következő 3 oldal',
  },
  DatePicker: {
    lang: {
      placeholder: 'Válasszon dátumot',
      rangePlaceholder: [
        'Kezdő dátum',
        'Befejezés dátuma',
      ],
      locale: 'hu_HU',
      today: 'Ma',
      now: 'Most',
      backToToday: 'Vissza a mai napra',
      ok: 'Ok',
      clear: 'Törlés',
      month: 'Hónap',
      year: 'Év',
      timeSelect: 'Időpont kiválasztása',
      dateSelect: 'Dátum kiválasztása',
      monthSelect: 'Hónap kiválasztása',
      yearSelect: 'Év kiválasztása',
      decadeSelect: 'Évtized kiválasztása',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY/MM/DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Előző hónap (PageUp)',
      nextMonth: 'Következő hónap (PageDown)',
      previousYear: 'Múlt év (Control + left)',
      nextYear: 'Jövő év (Control + right)',
      previousDecade: 'Előző évtized',
      nextDecade: 'Következő évtized',
      previousCentury: 'Múlt évszázad',
      nextCentury: 'Jövő évszázad',
    },
    timePickerLocale: {
      placeholder: 'Válasszon időt',
    },
  },
  TimePicker: {
    placeholder: 'Válasszon időt',
  },
  Calendar: {
    lang: {
      placeholder: 'Válasszon dátumot',
      rangePlaceholder: [
        'Kezdő dátum',
        'Befejezés dátuma',
      ],
      locale: 'hu_HU',
      today: 'Ma',
      now: 'Most',
      backToToday: 'Vissza a mai napra',
      ok: 'Ok',
      clear: 'Törlés',
      month: 'Hónap',
      year: 'Év',
      timeSelect: 'Időpont kiválasztása',
      dateSelect: 'Dátum kiválasztása',
      monthSelect: 'Hónap kiválasztása',
      yearSelect: 'Év kiválasztása',
      decadeSelect: 'Évtized kiválasztása',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY/MM/DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Előző hónap (PageUp)',
      nextMonth: 'Következő hónap (PageDown)',
      previousYear: 'Múlt év (Control + left)',
      nextYear: 'Jövő év (Control + right)',
      previousDecade: 'Előző évtized',
      nextDecade: 'Következő évtized',
      previousCentury: 'Múlt évszázad',
      nextCentury: 'Jövő évszázad',
    },
    timePickerLocale: {
      placeholder: 'Válasszon időt',
    },
  },
  Table: {
    filterTitle: 'Szűrők',
    filterConfirm: 'Alkalmazás',
    filterReset: 'Visszaállítás',
    selectAll: 'Jelenlegi oldal kiválasztása',
    selectInvert: 'Jelenlegi oldal inverze',
    sortTitle: 'Rendezés',
  },
  Modal: {
    okText: 'Alkalmazás',
    cancelText: 'Visszavonás',
    justOkText: 'Alkalmazás',
  },
  Popconfirm: {
    okText: 'Alkalmazás',
    cancelText: 'Visszavonás',
  },
  Transfer: {
    searchPlaceholder: 'Keresés',
    itemUnit: 'elem',
    itemsUnit: 'elemek',
  },
  Upload: {
    uploading: 'Feltöltés...',
    removeFile: 'Fájl eltávolítása',
    uploadError: 'Feltöltési hiba',
    previewFile: 'Fájl előnézet',
    downloadFile: 'Fájl letöltése',
  },
  Empty: {
    description: 'Nincs adat',
  },
};

export default localeValues;
